// extracted by mini-css-extract-plugin
module.exports = {"options":"QuizItem_options__3BO4R","quiz_img":"QuizItem_quiz_img__373ct","quiz_box":"QuizItem_quiz_box__2aXZG"};